module.exports = __webpack_public_path__ + "static1710991110236-0.0.5.6/img/gxh.48a38cc2.jpg";